/**
 * @author lifei
 * 功能： 移除指定的字符
 * @param str 字符串
 * @param strSlice 字符串片段
 * @param mode 移除的方式等，start 开始位置，end 结束位置，both 开始和结束， all 移除全部命中的字符串片段
 * @returns string
 */
export const removeChar = (str: string, char: string, mode: 'start' | 'end' | 'both' | 'all'): string => {
  switch (mode) {
    case 'all':
      return str.replace(new RegExp(char, 'g'), '')
    case 'both':
      return str.replace(new RegExp(`^${char}|${char}$`, 'g'), '')
    case 'end':
      return str.replace(new RegExp(`${char}$`), '')
    case 'start':
      return str.replace(new RegExp(`^${char}`), '')
    default: {
      const _exhaustiveCheck: never = mode
    }
  }
  return str
}
